import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel';
import theme from '@tcp/core/styles/themes/TCP';
import { routerPush } from '@tcp/core/src/utils';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Anchor from '../../../../../../common/atoms/Anchor';
import OrdersOverviewNewView from './OrdersOverviewNew.view';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/OrdersRedesignTile.style';
import OrderTileDetail from './OrderTileDetail.view';
import internalEndpoints from '../../../internalEndpoints';
import GlobalAccountDrawerLabels, {
  GLOBAL_ACCOUNT_DRAWER_LABELS,
  lblAccountDashboardNoOrders,
} from '../../../../../../../utils/labels/globalAccountDrawer.labels';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_RECOMMENDATIONS_LABEL,
  GlobalRecommendationLabels,
  lblCtaText,
} from '../../../../../../../utils/labels/globalRecommendations.labels';

const { breakpoints } = theme;
const CAROUSEL_OPTIONS = {
  autoplay: false,
  arrows: false,
  autoplaySpeed: 4000,
  infinite: false,
  initialSlide: 0,
  fade: false,
  speed: 300,
  dots: true,
  dotsClass: 'slick-dots',
  focusOnSelect: true,
  slidesToShow: 3.3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 2561,
      settings: {
        autoplay: false,
        arrows: false,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 5.5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 2300,
      settings: {
        autoplay: false,
        arrows: false,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 5.2,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 2100,
      settings: {
        autoplay: false,
        arrows: false,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 4.2,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 1800,
      settings: {
        autoplay: false,
        arrows: false,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 3.2,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: parseInt(breakpoints.large, 10) - 1,
      settings: {
        autoplay: false,
        arrows: false,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 2.5,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        autoplay: false,
        arrows: false,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
};

const OrdersRedesignTile = (props) => {
  const { orderList, className } = props;
  const handleShopNowClick = (e) => {
    e.preventDefault();
    routerPush(internalEndpoints.shopNowPage.link, internalEndpoints.shopNowPage.path);
  };

  return (
    <OrdersOverviewNewView isNoOrdersAvailable={!orderList.length} useRouterNavigation={true}>
      {orderList.length ? (
        <React.Fragment>
          <BodyCopy
            component="div"
            className={`${className} orders-carousel-tablet-desktop-view orders-redesign-carousel-new`}
          >
            <Carousel
              options={CAROUSEL_OPTIONS}
              carouselConfig={{
                customArrowLeft: null,
                customArrowRight: null,
                arrow: 'small',
                type: 'light',
              }}
              carouselTheme="dark"
            >
              {orderList.map((orderItem) => (
                <OrderTileDetail orderItem={orderItem} useRouterNavigation={true} />
              ))}
            </Carousel>
          </BodyCopy>
          <BodyCopy
            component="div"
            className={`${className} orders-carousel-mobile-view orders-redesign-carousel-new`}
          >
            <Carousel
              options={CAROUSEL_OPTIONS}
              carouselConfig={{
                customArrowLeft: null,
                customArrowRight: null,
                arrow: 'small',
                type: 'light',
              }}
              carouselTheme="dark"
            >
              {orderList.slice(0, 6).map((order) => (
                <OrderTileDetail orderItem={order} useRouterNavigation={true} />
              ))}
            </Carousel>
          </BodyCopy>
        </React.Fragment>
      ) : (
        <BodyCopy component="div" className={`${className} no-order-tile`}>
          <BodyCopy component="div" className="tileWrapper no-order-tileWrapper">
            <BodyCopy component="div" fontSize="fs16" fontFamily="secondary" fontWeight="normal">
              {getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ACCOUNT_DRAWER_LABELS}.${lblAccountDashboardNoOrders}`,
                GlobalAccountDrawerLabels
              )}
            </BodyCopy>
            <BodyCopy component="div" className="order-detail-link-wrapper">
              <Anchor
                fontSizeVariation="xlarge"
                underline
                anchorVariation="primary"
                to={'#'}
                asPath={'#'}
                aria-label="Order Detail"
                className="order-detail-link"
                onClick={(e) => handleShopNowClick(e)}
              >
                {getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_RECOMMENDATIONS_LABEL}.${lblCtaText}`,
                  GlobalRecommendationLabels
                )}
              </Anchor>
            </BodyCopy>
          </BodyCopy>
        </BodyCopy>
      )}
    </OrdersOverviewNewView>
  );
};

OrdersRedesignTile.propTypes = {
  className: PropTypes.string,
  orderList: PropTypes.arrayOf(Object),
};

OrdersRedesignTile.defaultProps = {
  className: '',
  orderList: [],
};

export default withStyles(OrdersRedesignTile, styles);
export { OrdersRedesignTile as OrdersRedesignTileVanilla };
